<template>
  <div class="overflow-hidden">
    <img
      src="img/camillo-coda-1.gif"
      class="fixed pin-r pt-32"
      style="margin-right: -270px; transform: rotate(45deg); padding-top: 290px;"
    >
    <div class="container mx-auto px-4 relative z-10">
      <div class="pt-20">
        <div class="text-center px-10 pb-5">
          <img
            src="img/Logo_Camillo.svg"
            alt="Camillo"
          >
        </div>
        <form
          @submit.prevent="handleSubmit"
          class="rounded px-4 pt-6 pb-8 mb-4"
        >
          <div class="mb-4 ">
            <input
              type="text"
              v-model="username"
              name="username"
              :placeholder="$t('all.common_username')"
              class=" appearance-none border w-full py-4 px-4 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
              :class="{ 'border-red': submitted && !username }"
            />
            <div
              v-show="submitted && !username"
              class="text-red text-xs italic"
            >
              {{$t('all.auth_insert_username')}}
            </div>
          </div>
          <div class="mb-6 items-center justify-between">
            <button class="w-full bg-blue-dark block hover:bg-blue-dark text-white font-bold py-4 px-6 rounded focus:outline-none focus:shadow-outline">
              {{$t('all.common_continue')}}
            </button>
          </div>
          <div class="mb-6 text-center">
            <router-link
              class="text-pink-dark  inline-block align-baseline font-bold text-sm hover:text-blue-darker"
              :to="{name: 'Login'}"
            >{{$t('all.auth_continue_login')}}</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      submitted: false,
      username: '',
    };
  },
  computed: {
    ...mapGetters({
      getUsername: 'authentication/username',
    }),
  },
  created() {
    this.logout();
    this.username = this.getUsername;
  },
  methods: {
    ...mapActions('authentication', ['lostPassword', 'logout']),
    handleSubmit() {
      this.submitted = true;
      const { username } = this;
      if (username) {
        this.lostPassword(username);
      }
    },
  },
};
</script>
